import { render, staticRenderFns } from "./speed-change.vue?vue&type=template&id=9d7961f6&scoped=true"
import script from "./speed-change.vue?vue&type=script&lang=js"
export * from "./speed-change.vue?vue&type=script&lang=js"
import style0 from "./speed-change.vue?vue&type=style&index=0&id=9d7961f6&prod&lang=less&scoped=true"
import style1 from "./speed-change.vue?vue&type=style&index=1&id=9d7961f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7961f6",
  null
  
)

export default component.exports